import { render, staticRenderFns } from "./setSortDialog.vue?vue&type=template&id=8119adf2&scoped=true"
import script from "./setSortDialog.vue?vue&type=script&lang=js"
export * from "./setSortDialog.vue?vue&type=script&lang=js"
import style0 from "./setSortDialog.vue?vue&type=style&index=0&id=8119adf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119adf2",
  null
  
)

export default component.exports